import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  const coverUrls: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20dark%20fantasy%20hunter%20with%20blue%20energy%20aura%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20manga%20style%20art%2C%20clean%20composition%2C%20vibrant%20contrast%2C%20professional%20manhwa%20cover&width=600&height=800&seq=cover-solo-leveling&orientation=portrait',
    2: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20young%20woman%20with%20makeup%2C%20soft%20pastel%20aesthetic%2C%20shojo%20manga%20style%2C%20Korean%20digital%20illustration%2C%20romantic%20atmosphere%2C%20clean%20composition%2C%20professional%20cover%20art&width=600&height=800&seq=cover-true-beauty&orientation=portrait',
    3: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20apocalyptic%20scene%20with%20protagonist%20holding%20a%20book%2C%20dramatic%20dark%20atmosphere%2C%20mysterious%20constellations%2C%20Korean%20digital%20art%2C%20action%20fantasy%20style%2C%20professional%20manhwa%20cover&width=600&height=800&seq=cover-omniscient&orientation=portrait',
    4: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20elegant%20queen%20in%20lavish%20royal%20gown%2C%20palace%20background%2C%20golden%20accents%2C%20romance%20drama%20style%2C%20Korean%20digital%20illustration%2C%20ornate%20composition%2C%20professional%20cover&width=600&height=800&seq=cover-remarried-empress&orientation=portrait',
    5: 'https://readdy.ai/api/search-image?query=Korean%20action%20drama%20manhwa%20cover%2C%20dual%20identity%20concept%20with%20two%20contrasting%20male%20figures%2C%20urban%20school%20setting%2C%20dramatic%20lighting%2C%20Korean%20digital%20art%2C%20realistic%20style%2C%20professional%20cover&width=600&height=800&seq=cover-lookism&orientation=portrait',
    12: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20cover%2C%20mysterious%20tower%20rising%20to%20sky%2C%20young%20hero%20with%20determination%2C%20epic%20scale%2C%20fantasy%20world%2C%20Korean%20digital%20illustration%2C%20cinematic%20composition%2C%20professional%20cover&width=600&height=800&seq=cover-tower-of-god&orientation=portrait',
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="font-label text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-2">
              热门推荐
            </h2>
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 italic">
              大家都在看
            </h3>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-[480px]">
            根据读者阅读量、收藏数和评分综合计算，每日更新热门排行，帮您发现最受欢迎的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className={`group block rounded-2xl overflow-hidden transition-all duration-300 ${
                index === 2 ? 'bg-primary-800' : 'bg-background-50'
              }`}
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-t-2xl">
                <img
                  src={coverUrls[comic.id] || coverUrls[1]}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-secondary-500 text-foreground-950 text-xs font-bold px-2.5 py-1 rounded-full">
                    {comic.category === 'action' ? '热血' : comic.category === 'love' ? '恋爱' : comic.category === 'fantasy' ? '奇幻' : '推荐'}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="bg-background-50/90 text-foreground-800 text-xs font-semibold px-2 py-1 rounded-full">
                    {comic.rating}分
                  </span>
                </div>
              </div>
              <div className={`p-5 ${index === 2 ? 'text-white' : ''}`}>
                <h3 className={`font-heading text-lg font-bold mb-2 line-clamp-2 ${index === 2 ? 'text-white' : 'text-foreground-900'}`}>
                  {comic.title}
                </h3>
                <p className={`text-xs mb-3 ${index === 2 ? 'text-white/60' : 'text-foreground-500'}`}>
                  {comic.author} · {comic.status} · {comic.chapters}话
                </p>
                <div className="flex items-center gap-2">
                  <i className={`ri-eye-line text-xs ${index === 2 ? 'text-white/50' : 'text-foreground-400'}`}></i>
                  <span className={`text-xs ${index === 2 ? 'text-white/50' : 'text-foreground-400'}`}>{comic.views}次阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-medium text-sm transition-colors"
          >
            查看更多热门漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}